<template>
  <v-container
      fill-height
      fluid
      grid-list-xl
      class="left-sidebar">
    <v-layout
        justify-center
        wrap>
      <v-flex
          md12>
        <v-card
            elevation="2"
            class="card-body">
            <v-card-title class="text-h6">
              {{ edit ? $t('mobile.editProductDesign') : $t('mobile.addProductDesign')}}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-form ref="addProductDesignForm">
                <v-row class="dialog-card-body">
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                        v-model="designName"
                        :placeholder="$t('mobile.designName')"
                        :error-messages="designNameErrors"
                    />
                    <v-row>
                      <v-col cols="6" sm="12" md="6">
                        <v-flex>
                        <v-text-field
                            v-model="designPrice"
                            :label="$t('mobile.price')"
                            :placeholder="$t('mobile.price')"
                        />
                      </v-flex>
                      </v-col>
                      <v-col cols="6" sm="12" md="6">
                        <v-flex>
                        <v-select
                            v-model="designCurrency"
                            :items="currencies"
                            :placeholder="$t('product.currency')"
                            :label="$t('product.currency')"
                            item-text="value"
                            item-value="value"
                        ></v-select>
                      </v-flex>
                      </v-col>
                    </v-row>
                    <div class="uploader-container">
                      <label for="iconSmall">{{ $t('mobile.iconSmall')}}</label><br>
                      <i
                          v-if="iconSmall"
                          class="mdi mdi-delete delete delete-sign-icon-small image"
                          title="delete"
                          @click="removeImage('iconSmall')">

                      </i>
                      <input @change="setImage('iconSmall', $event)" id="iconSmall" type='file' accept="image/*"/>
                      <img class="image" v-bind:src="getImageUrl(iconSmall)">
                    </div>
                    <!-- design image starts here -->
                    <div class="uploader-container">
                      <label for="designImage">{{ $t('mobile.image')}}</label><br>
                      <i
                          v-if="designImage"
                          class="mdi mdi-delete delete delete-sign-design-image image"
                          title="delete"
                          @click="removeImage('designImage')">

                      </i>
                      <input @change="setImage('designImage', $event)" id="designImage" type='file' accept="image/*"/>
                      <img class="image" v-bind:src="getImageUrl(designImage)">
                    </div>
                    <!-- design image preview starts here -->
                    <div class="uploader-container">
                      <label for="designImage">{{ $t('mobile.imagePreview')}}</label><br>
                      <i
                          v-if="imagePreview"
                          class="mdi mdi-delete delete delete-sign-design-image-preview image"
                          title="delete"
                          @click="removeImage('imagePreview')">

                      </i>
                      <input @change="setImage('imagePreview', $event)" id="imagePreview" type='file' accept="image/*"/>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn
                        v-if="imagePreview"
                        class="add-new mb-1 mt-8 mr-3"
                        dark
                        @click="addLayer()"
                    >
                      {{ $t('Add Layer')}}
                    </v-btn>
                    <v-row v-for="(layer, index) in layers" :key="index" class="layer-options-container">
                      <v-col cols="12">
                        <v-row>
                          <i
                              class="mdi mdi-delete delete delete-layer"
                              title="delete"
                              @click="removeLayer(index)">

                          </i>
                          <v-select
                              class="layer-type-select"
                              v-model="layer.type"
                              :items="['image', 'label']"
                              :placeholder="$t('Layer type')"
                              :label="$t('Layer type')"
                          ></v-select>
                          <v-switch :label="$t('Editable')" v-model="layer.editable"/>
                        </v-row>
                      </v-col>
                      <v-col>
                        <input v-if="layer.type === 'image'" @change="setImageLayer(index, $event)" :id="'layer' + index" type='file' accept="image/*"/>
                        <v-text-field
                            @change="setTextLayer(index, $event)"
                            v-if="layer.type === 'label'"
                            v-model="layer.text"
                            :label="$t('Insert text')"
                            :placeholder="$t('Insert text')"
                        />
                        <v-text-field
                            @change="setTextLayerSize(index, $event)"
                            v-if="layer.type === 'label'"
                            v-model="layer.font_size"
                            :label="$t('Font size')"
                            :placeholder="$t('Font size')"
                        />
                        <v-select
                            class="layer-select"
                            v-model="layer.text_alignment"
                            v-if="layer.type === 'label'"
                            @change="setTextLayerAlignment(index, $event)"
                            :items="['left', 'center', 'right']"
                            :placeholder="$t('Text alignment')"
                            :label="$t('Text alignment')"
                        ></v-select>
                        <div v-if="layer.type === 'label'">
                          <h6>Choose fonts</h6>
                          <v-data-table
                              :headers="headersFonts"
                              :items="getAllFonts"
                              :rows-per-page-items ="rowsAmount"
                              :search="searchFonts"
                              class="elevation-1 table-scroll"
                          >
                            <template v-slot:item="props">
                              <tr>
                                <th>
                                  <v-checkbox
                                      :style="{ marginTop: 0 }"
                                      @change="setTextLayerFont(index, $event)"
                                      v-model="layer.font_name"
                                      primary
                                      hide-details
                                      v-bind:value="props.item.name"
                                  ></v-checkbox>
                                </th>
                                <td>
                                  <div :style="{ fontFamily: props.item.name, fontSize: '18px' }">{{ props.item.name }}</div>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                          <h6 class="font-color-header">Font color</h6>
                          <v-row>
                            <v-col cols="4">
                              <v-row>
                                <v-col cols="6">
                                  <v-color-picker
                                      class="font-color-picker"
                                      dot-size="25"
                                      mode="hexa"
                                      hide-sliders
                                      hide-mode-switch
                                      v-model="colorPicker"
                                      swatches-max-height="200"
                                  ></v-color-picker>
                                </v-col>
                                <v-col cols="6">
                                  <v-btn class="add-new" dark @click="setTextLayerColor(index, colorPicker)">
                                    {{ $t('apply')}}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <div class="croppers-container">
                      <div class="single-cropper-container" v-for="(layer, index) in layers" :key="index">
                        <cropper
                            :class="'cropper' + index"
                            v-show="showMarker"
                            ref="cropper"
                            class="cropper"
                            :src="imagePreview"
                            @change="cropperChange($event, layer, index)">
                        </cropper>
                      </div>
                    </div>
                    <div v-if="!showMarker" class="image-preview-container">
                      <img class="image-preview" :src="imagePreview">
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  class="add-new mb-1 mt-8 mr-3"
                  dark
                  @click="cancelProductDesign()"
              >
                {{ $t('cancel')}}
              </v-btn>
              <v-btn
                  class="add-new mb-1 mt-8 mr-3"
                  dark
                  @click="submitProductDesign()">
                {{ $t('submit')}}
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {  mapGetters } from 'vuex';
import i18n from '../../i18n'
import {required} from "vuelidate/lib/validators";
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import axios from "axios";

export default {
  components: {
    Cropper
  },

  data () {
    return {
      edit: false,
      coordinates: null,
      showMarker: false,
      designName: null,
      designPrice: null,
      designCurrency: 'RSD',
      iconSmall: null,
      designImage: null,
      imagePreview: null,
      colorPicker: null,
      layers: [],
      searchFonts: '',
      currencies: Object.values({
        EUR: {id: 0, value: 'EUR'},
        RSD: {id: 1, value: 'RSD'},
      }),
      headersFonts: [
        { text: i18n.t('')},
        { text: i18n.t('mobile.fontName'), value: 'name'},
      ],
      rowsAmount: [10,20,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
    }

  },
  validations: {
    designName: { required },
    editDesignName: { required },
  },
  computed: {
    ...mapGetters([
      'getAllFonts'
    ]),

    designNameErrors(){
      const errors = [];
      if (!this.$v.designName.$dirty) return errors;
      !this.$v.designName.required && errors.push(i18n.tc('fieldRequired'));
      return errors;
    }
  },
  methods: {
    addLayer() {
      this.layers.push({
        type: null,
        editable: false,
        url: "",
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        text: "",
        font_size: 10,
        font_name: "",
        text_alignment: 'center',
        text_color: '#FFFFFF'
      })
      this.triggerMarker()
    },
    removeLayer(index) {
      this.layers.splice(index, 1);
    },
    triggerMarker () {
      this.showMarker = true
      // this.$nextTick(() => this.$refs.cropper.refresh());
    },
    cropperChange (event, layer) {
      this.coordinates = event.coordinates;

      if(layer) {
        layer.top = event.coordinates.top
        layer.left = event.coordinates.left
        layer.width = event.coordinates.width
        layer.height = event.coordinates.height
      }
    },
    async submitProductDesign() {
      let images = new Promise((resolve) => {
        if(this.layers.length > 0) {
          let count = 0
          this.layers.forEach((layer, index) => {
            const imageForm = new FormData()
            if(typeof layer.url !== 'string') {
              imageForm.append('file', layer.url)
              axios.post(`file`, imageForm ).then(resp => {
                resp.data.data ? this.layers[index].url = resp.data.data.url : this.layers[index].url = ''
                if(count === this.layers.length - 1) {
                  resolve()
                } else {
                  count ++
                }
              })
            } else {
              if(count === this.layers.length - 1) {
                resolve()
              } else {
                count ++
              }
            }
          })
        } else {
          resolve()
        }
    })

    await images.then(() => {
      let image = document.getElementById('designImage').files[0] ? document.getElementById('designImage').files[0] : this.designImage,
          imagePreview = document.getElementById('imagePreview').files[0] ? document.getElementById('imagePreview').files[0] : this.imagePreview,
          iconSmall = document.getElementById('iconSmall').files[0] ? document.getElementById('iconSmall').files[0] : this.iconSmall;
      let formData = new FormData();
      formData.append('title', this.designName);
      formData.append('small_icon', iconSmall);
      formData.append('image', image);
      formData.append('preview_image', imagePreview);
      if(this.designPrice) {
        formData.append(`prices[0][currency]`, this.designCurrency);
        formData.append(`prices[0][value]`, this.designPrice);
      }

      for (const layer of this.layers) {
        const index = this.layers.indexOf(layer);
        formData.append(`layers[${index}][type]`, layer.type);
        formData.append(`layers[${index}][editable]`, layer.editable);
        formData.append(`layers[${index}][url]`, layer.url);
        formData.append(`layers[${index}][left]`, layer.left);
        formData.append(`layers[${index}][top]`, layer.top);
        formData.append(`layers[${index}][width]`, layer.width);
        formData.append(`layers[${index}][height]`, layer.height);
        formData.append(`layers[${index}][text]`, layer.text);
        if(layer.text_color) {
          const fontColor = layer.text_color.toLowerCase()
          formData.append(`layers[${index}][text_color]`, fontColor);
        }
        if(layer.text_alignment) {
          formData.append(`layers[${index}][text_alignment]`, layer.text_alignment);
        }
        formData.append(`layers[${index}][font_size]`, layer.font_size);
        formData.append(`layers[${index}][font_name]`, layer.font_name);
      }
      if(this.$v.designName.$invalid || this.designImage.value === ''
          || this.imagePreview.value === '' || this.iconSmall.value === ''){
        this.$v.$touch();
        image.style.color = 'red';
        imagePreview.style.color = 'red';
        iconSmall.style.color = 'red';
        return;
      } else {
        this.edit ? this.$store.dispatch('UPDATE_PRODUCT_DESIGN', {id: this.$route.params.id, form: formData})
            .then(() => {
              this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS')
              this.cancelProductDesign();
            }) : this.$store.dispatch('CREATE_PRODUCT_DESIGN', formData)
            .then(() => {
              this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS')
              this.cancelProductDesign();
            })

      }
      })
    },
    getImageUrl: function (image) {
      if (typeof image === 'string') {
        return image
      }

      if (image instanceof File) {
        return URL.createObjectURL(image)
      }

      return ''
    },
    removeImage(property){
      if (confirm(i18n.t(`areYouSureToDelete`))) {
        this[property] = null
        document.getElementById(property).value = "";
      }
    },
    setImage(attribute, event) {
      this[attribute] = URL.createObjectURL(event.target.files[0])
    },
    setImageLayer(index, event) {
      this.layers[index].url = event.target ? event.target.files[0] : event
      const imageUrl = event.target ? URL.createObjectURL(event.target.files[0]) : event
      const fill = document.getElementsByClassName('vue-preview--fill')[index]
      fill.style.backgroundImage = 'url(' + imageUrl + ')'
      fill.style.backgroundSize = 'contain'
      fill.style.backgroundPosition = 'center center'
      this.$refs.cropper[index].refresh()
    },
    setTextLayer(index, event) {
      this.layers[index].text = event
      const fill = document.getElementsByClassName('vue-preview--fill')[index]
      fill.classList.add('text-layer')
      fill.innerHTML = event
    },
    setTextLayerSize(index, event) {
      this.layers[index].font_size = event
      const fill = document.getElementsByClassName('vue-preview--fill')[index]
      fill.style.fontSize = event + 'px'
    },
    setTextLayerColor(index, event) {
      if(event.hex) {
        this.layers[index].text_color = event.hex
        const fill = document.getElementsByClassName('vue-preview--fill')[index]
        fill.style.color = event.hex
      } else {
        this.layers[index].text_color = event
        const fill = document.getElementsByClassName('vue-preview--fill')[index]
        fill.style.color = event
      }
    },
    setTextLayerFont(index, font) {
      const fill = document.getElementsByClassName('vue-preview--fill')[index]
      if(font) {
        fill.style.fontFamily = font
      } else {
        fill.style.fontFamily = null
      }

    },
    setTextLayerAlignment(index, alignment) {
      const fill = document.getElementsByClassName('vue-preview--fill')[index]
      if(alignment) {
        fill.style.justifyContent = alignment
      } else {
        fill.style.justifyContent = 'center'
      }

    },
    cancelProductDesign(){
      this.$router.push(`/${i18n.locale}/mobile-layout`)
    },

  },
  mounted() {
    this.$store.dispatch('LOAD_ALL_FONTS');
    if(this.$route.params.id) {
      this.edit = true
      this.$store.dispatch('GET_PRODUCT_DESIGN', this.$route.params.id)
          .then(res => {
            let response = res.data.data;
            this.editDesignName = response.title;
            this.showMarker = true
            this.designName = response.title
            this.designPrice = response.prices[0] ? response.prices[0].value : ''
            this.designCurrency = response.prices[0] ? response.prices[0].currency : ''
            this.iconSmall = response.small_icon
            this.designImage = response.image
            this.imagePreview = response.preview_image

            response.layers && response.layers.forEach((layer, index) => {
              if(layer.type === 'image') {
                this.layers.push(layer)
                setTimeout(()=>{
                  this.setImageLayer(index, layer.url)
                  this.$refs.cropper[index].setCoordinates({
                    width: layer.width,
                    height: layer.height,
                    left: layer.left,
                    top: layer.top
                  })
                }, 1)
              }
              if(layer.type === 'label') {
                this.layers.push(layer)
                setTimeout(()=>{
                  this.setTextLayer(index, layer.text)
                  this.setTextLayerSize(index, layer.font_size)
                  this.setTextLayerFont(index, layer.font_name)
                  if(layer.text_color) {
                    this.setTextLayerColor(index, layer.text_color)
                  }
                  if(layer.text_alignment) {
                    this.setTextLayerAlignment(index, layer.text_alignment)
                  } else {
                    this.setTextLayerAlignment(index, 'center')
                    layer.text_alignment = 'center'
                    console.log('layer', layer)
                  }
                  this.$refs.cropper[index].setCoordinates({
                    width: layer.width,
                    height: layer.height,
                    left: layer.left,
                    top: layer.top
                  })
                }, 1)
              }
            })
          })
    }
  }
}
</script>

<style lang="less">
.active-web{
  margin-top: -20px !important;
}
.categories-style{
  margin-top: 15px !important;
}
.icons-style-title{
  margin-top: 30px;
  margin-bottom: 12px;
  display: block;
  color: #4f4f4f;
  font-size: 16px;
}
.icons-style{
  margin-bottom: 5px;
}
.images-wrapper{
  margin-top: 12px;
  color: #4f4f4f;
  font-size: 16px;

  .position-images{
    border: 1px solid #eee;
    border-radius: 5px;
    margin-bottom: 1px;
    margin-right: 10px;
  }
  .position-number{
    display: inline-block;
    position: relative;
    left: 10%;
  }
}
.tree-style{
  margin-top: 35px;
}

.image{
  max-width: 235px;
  max-height: 150px;
  margin-bottom: 5px;
  border-radius: 2px;
}

.delete {
  margin-right: 15px;
}

.uploader-container {
  margin-bottom: 10px;
}

.image-preview-container {
  max-width: 100%;
  height: auto;

  .image-preview {
    max-width: 100%;
    height: auto;
  }
}

.croppers-container {
  max-width: 100%;
  position: relative;
  .single-cropper-container:not(:first-child) {
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100%;
    max-height: 100%;

    .cropper {
      max-width: 100%;
      max-height: 100%;
    }

    .vue-advanced-cropper__foreground {
      opacity: 0;
    }

    .vue-advanced-cropper__image {
      display: none;
    }

    .vue-preview__image {
      display: none;
    }

    .vue-advanced-cropper__background {
      opacity: 0;
    }
  }
  .single-cropper-container:nth-child(1) {
    position: relative;

    .layer-image {
      position: absolute;
    }

    .vue-advanced-cropper__foreground {
      opacity: 0;
    }

    .vue-preview--fill {
      background-size: contain;
      background-position: center center;
    }
  }

  .vue-preview__wrapper {
    z-index: -100;
  }

  .text-layer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

}

.delete-layer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.layer-options-container {
  padding-top: 20px;
  padding-right: 20px;
}

.layer-type-select {
  margin-right: 10px;
}

.font-color-picker {
  .v-color-picker__canvas {
    display: none;
  }
  .v-color-picker__edit {
    margin-top: 0;
  }

  .v-color-picker__controls {
    padding: 5px 0 0;
  }
}

.font-color-header {
  margin-top: 15px;
}
</style>
